import draggable from './draggable'
import resizable from './resizable'

export { draggable, resizable }
export default {
    draggable,
    resizable,
}
